import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { designTokens } from '../ui/foundation/DesignTokens';

export const SortContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

// Styled dropdown trigger that looks like a select
export const SortTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: white;
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.md};
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  font-weight: 500;
  color: ${designTokens.colors.primary[600]};
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 160px;
  justify-content: space-between;

  &:hover {
    border-color: ${designTokens.colors.gray[300]};
    background: ${designTokens.colors.gray[50]};
  }

  &:focus {
    outline: none;
    border-color: ${designTokens.colors.primary[500]};
    box-shadow: 0 0 0 3px ${designTokens.colors.primary.ring};
  }
`;

export const SortSelectedOption = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  font-weight: 500;
  color: ${designTokens.colors.primary[600]};
`;

export const SortActionIcon = styled(FontAwesomeIcon)`
  font-size: 0.875rem;
  color: ${designTokens.colors.gray[500]};
  transition: transform 0.2s ease;

  &.open {
    transform: rotate(180deg);
  }
`;

export const SortModalContainer = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 10;
  background: white;
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.md};
  box-shadow: ${designTokens.shadows.md};
  min-width: 160px;
  overflow: hidden;
`;

export const SortOption = styled.div`
  padding: 10px 14px;
  font-size: 0.875rem;
  font-family: ${designTokens.fonts.body};
  color: ${designTokens.colors.gray[700]};
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${designTokens.colors.gray[50]};
  }

  &.active {
    background: ${designTokens.colors.primary[50]};
    color: ${designTokens.colors.primary[600]};
    font-weight: 500;
  }
`;
